import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from "../";
import { IBaseResponse, IDonorProfilePostTransplant } from '@nkr/models/index';

export interface IDonorProfilePostTransplantResponse {
    data: {
        success: boolean;
        results: IDonorProfilePostTransplant;
    }
}

export const ActionCreators = {
    getProfilePostTransplant: (centerId: number, donorId: number) => async (dispatch: Dispatch<IApplicationState>): Promise<IDonorProfilePostTransplantResponse> => {
        let options = {
            url: `${__API__}/center/${centerId}/donor/${donorId}/post-transplant`
        };

        return await dispatch(AuthActionCreators.apiGet(options));
    },
    saveProfilePostTransplant: (centerId: number, donorId: number, whichKidneyDonated: string, crossClampDateTime: string, perfusionCompletionDateTime: string, completedFormsAndChecklists: File) => async (dispatch: Dispatch<IApplicationState>): Promise<IBaseResponse> => {
        let formData = new FormData();

        formData.append('whichKidneyDonated', whichKidneyDonated);
        formData.append('crossClampDateTime', crossClampDateTime);
        formData.append('perfusionCompletionDateTime', perfusionCompletionDateTime);
        formData.append('completedFormsAndChecklists', completedFormsAndChecklists);

        let options = {
            url: `${__API__}/center/${centerId}/donor/${donorId}/post-transplant`,
            data: formData
        };

        return await dispatch(AuthActionCreators.apiPostFormData(options));
    },
}